import $ from 'jquery';

export default () => {
    const loadMore = $('.js-post-list-more');

    if (loadMore.is('*')) {
        const content = $('.js-post-list-content');

        loadMore.on('click', function() {
            let request = new XMLHttpRequest();
            const count = parseInt(loadMore.attr('data-count')) + 3;
            const type = loadMore.attr('data-type');

            loadMore.attr('data-count', count);

            request.onreadystatechange = function() {
                if (request.readyState === XMLHttpRequest.DONE) {
                    if (request.status === 200) {
                        const response = JSON.parse(request.responseText);
                        content.html(response.posts);

                        if (!$('.js-post-list-load-more').is('*')) {
                            loadMore.hide();
                        }
                    }
                }
            };

            request.open('GET', `${globals.urls.ajax}?action=postList&type=${type}&count=${count}`, true);
            request.send();
        });
    }
}



// WEBPACK FOOTER //
// ../src/scripts/modules/post-list.js